import React, { useMemo } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import CardSetupForm from './CardSetupFrom';
import { Styles, StyledHr } from '../Styles/AddCardStyle';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { Row, Col } from 'reactstrap';
import { FaTimes } from 'react-icons/fa';
import { usePaymentSecurity } from './usePaymentSecurity';

import config from '../../../config';

const publicKey = config.config.STRIPE.publicKey;
const connectedAccountID = config.config.STRIPE.connectedAccountID;

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.

const resolveStripePublicKey = () => {
  if (!publicKey) return null;

  const isHttp = typeof window !== 'undefined' && window.location && window.location.protocol === 'http:';
  const testKeyOverride = process.env.REACT_APP_STRIPE_TEST_PUBLIC_KEY || process.env.REACT_APP_STRIPE_PUBLIC_KEY_TEST || null;
  const isLiveKey = typeof publicKey === 'string' && publicKey.startsWith('pk_live_');
  const isTestKey = typeof publicKey === 'string' && publicKey.startsWith('pk_test_');
  const isValidTestOverride = typeof testKeyOverride === 'string' && testKeyOverride.startsWith('pk_test_');

  if (isHttp) {
    if (isValidTestOverride) {
      return testKeyOverride;
    }

    if (isLiveKey) {
      return null;
    }

    if (isTestKey) {
      return publicKey;
    }
  }

  return publicKey;
};

export const AddCard = ({ closePaymentModal }) => {
  const stripePromise = useMemo(() => {
    const stripeKey = resolveStripePublicKey();
    return stripeKey
      ? loadStripe(stripeKey, {
          stripeAccount: connectedAccountID
        })
      : Promise.resolve(null);
  }, []);

  // PCI SAQ 11.6.1.b compliance - Payment page tamper detection
  usePaymentSecurity();

  return (
    <Styles className="store-manager-container">
      <button
        style={{
          position: 'relative',
          top: '2.7rem',
          left: '33.7rem',
          fontSize: '1.5rem',
          cursor: 'pointer',
          color: 'hsl(360, 67%, 44%)',
          zIndex: '1',
          background: 'transparent'
        }}
        onClick={closePaymentModal}
      >
        <FaTimes />
      </button>
      <Card>
        <CardHeader className="store-header">
          <h4>Add Card</h4>
          <StyledHr />
        </CardHeader>
        <CardBody>
          <Row>
            <Col>
              <Elements stripe={stripePromise}>
                <CardSetupForm />
              </Elements>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Styles>
  );
};
